// The new, streamlined interface (9 October 2026): the list of broadcasters.
export default {
  titre: 'Broadcasters',
  sousTitre: {
    chaines: 'Audience share for {mois}, compared with {avant} · Médiamétrie, viewers aged 4+',
    chainesSansAvant: 'Audience share for {mois} · Médiamétrie, viewers aged 4+',
    chainesSansMesure: 'Who watches each channel, how its audience share moves, what its audience talks about',
    plateformes: 'The rankings platforms publish, and the formats tested for them',
  },
  erreur: 'Broadcasters could not be read',
  type: {
    libelle: 'Type of broadcaster',
    chaines: 'Channels',
    plateformes: 'Platforms',
  },
  recherche: {
    libelle: 'Search for a broadcaster',
    placeholder: 'Search',
  },
  legende: {
    chaines: 'Channels, by audience share',
    plateformes: 'Platforms',
  },
  colonne: {
    chaine: 'Channel',
    plateforme: 'Platform',
    pda: 'Audience share',
    echelle: 'Scale',
    surUnMois: 'Over a month',
    mesure: 'Measurement',
    formats: 'Formats tested',
    public: 'Its audience',
  },
  stable: 'stable',
  compareA: 'vs {mois}',
  classementPublie: 'Published ranking',
  horsMediamat: 'Outside Médiamat',
  formatsTestes: '{n} formats tested | {n} format tested | {n} formats tested',
  aucunFormat: 'None',
  ouvrir: 'Open',
  ouvrirLaFiche: 'Open {nom}’s profile',
  aucun: {
    chaines: 'No channel matches “{q}”.',
    plateformes: 'No platform matches “{q}”.',
  },
  vide: {
    chaines: 'No channels yet.',
    plateformes: 'No platforms yet.',
  },
  note: {
    chaines: 'Monthly Médiamat, viewers aged 4+. Platforms have their own tab: published rankings and formats tested.',
    plateformes: 'Platforms are not in Médiamat: what gets recorded there is the rankings they publish.',
  },
}
